const lateralMenuToggleReducer = (state = false, action) => {
  if (action.type === 'TOGGLE_LATERALMENU') {
    return action.payload;
  }
  return state;
};

export default lateralMenuToggleReducer;
